export const CHANGE_ITEM = "project/CHANGE_ITEM";
export const ADD_BASIC = "project/ADD_BASIC";
export const ADD_NORMAL = "project/ADD_NORMAL";
export const ADD_SUB = "project/ADD_SUB";
export const REMOVE_BASIC = "proejct/REMOVE_BASIC";
export const REMOVE_NORMAL = "proejct/REMOVE_NORMAL";
export const REMOVE_SUB = "proejct/REMOVE_SUB";
